import * as React from 'react';
import IInputValidation, { TInputValidation } from './IInputValidation';
import { isEmail, isUrl } from '@features/utils/functions';
import { updateValidationCounter } from '@company/features/action.company';
import moment from 'moment';

import * as styles from './InputValidationStyles.module.scss';

export default class Validation extends React.Component<IInputValidation, TInputValidation> {

  state:TInputValidation = {
    wasError: false,
    error: null,
  };

  UNSAFE_componentWillMount() {
    this.checkValue(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps: IInputValidation) {
    this.checkValue(nextProps);
  }

  checkValue(props: IInputValidation) {
    const value = props.value === undefined ? this.splitedValue(props) : props.value;
    if (value !== undefined) this.validation(value);
  }

  splitedValue(props: IInputValidation) {
    if (typeof(props.children) === 'string') return props.children;
    if (props.children.props.children !== undefined) return props.children.props.children;
    if (props.children.props.value !== undefined) return props.children.props.value;
    if (props.children.props._this.state) {
      const splited = props.children.props.name.split('.');
      if (splited.length === 2) return props.children.props._this.state.data[splited[0]][splited[1]];
      return props.children.props._this.state.data[props.children.props.name];
    }
    return undefined;
  }

  validation = (value: any) => {
    let error = null;

    switch (this.props.type) {
      case 'yymmdd':
        const literalDate = new RegExp(
          '^(([0-9])|([0-2][0-9])|([3][0-1]))\\xa0(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\\xa0\\d{4}$'
        );
        if (!literalDate.test(value) && !moment(value, 'YYYY-MM-DD', true).isValid()) error = 'Date format: YYYY-MM-DD';
        break;

      case 'noEmpty':
        if (value !== null && String(value).trim().length === 0) error = `Value can't be an empty`;
        break;

      case 'URL':
        if (!isUrl(value)) error = `Value must be an URL`;
        break;

      case 'UrlEmpty':
        if (value !== null && value.length > 0 && !isUrl(value)) error = 'Value must be an URL';
        break;

      case 'email':
        if (!isEmail(value)) error = 'Value must be an email';
        break;

      case 'year':
        if (value && (value % 1 !== 0 || value <= 1900 || value > new Date().getFullYear())) {
          error = 'Wrong value';
        }
        break;

      case 'companyDescription':
        if (value !== null) {
          if (value.length < 20) error = 'Minimum 20 characters';
          if (value.length === 0) error = `Value can't be an empty`;
        }
        break;

      case 'fundingMoney':
        let _value = value;
        const regex = /^[0-9.]+$/;

        _value = String(_value).replace(/k|M|B|T|P|E|\$|/g, '');
        if (!regex.test(_value)) error = 'Value must be a number';
        break;

      case 'city':
        if (value && value.length < 3) error = 'Minimum 3 characters';
        break;
    }

    this.setState({ error }, () => {
      if (this.props.dispatch) {
        if (this.state.error && !this.state.wasError) {
          this.props.dispatch(updateValidationCounter(1));
          this.setState({ wasError: true });
        } else if (this.state.wasError && !this.state.error) {
          this.props.dispatch(updateValidationCounter(-1));
          this.setState({ wasError: false });
        }
      }

      if (this.props.handleError) {
        this.props.handleError.fun(this.props.handleError.name, Boolean(this.state.error));
      }
    });
  }

  componentWillUnmount() {
    if (this.state.wasError && this.props.dispatch) {
      this.props.dispatch(updateValidationCounter(-1));
    }
  }

  render() {
    const { props } = this;
    const className = this.props.cl ? styles[this.props.cl] : null;
    return (
      <div className={this.state.error && !props.hide ? [styles.error, className].join(' ') : className}>
        {props.children}
        {this.state.error && !props.hide ? <p>{this.state.error}</p> : null}
      </div>
    );
  }
}

